import React from "react";
import { Row, Col, Card, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import mainImage from "../../assets/heroes-cup.jpg"; // ✅ Heroes Cup main image
import card1 from "../../assets/bloom-main.jpg"; // ✅ Smaller card (Bloom)
import card2 from "../../assets/jui-news-image.png"; // ✅ Smaller card (Jiu-jitsu)

const { Title, Paragraph, Text } = Typography;

const HeroesNewsDetail = () => {
  const navigate = useNavigate();

  const handleViewAll = () => {
    navigate("/news");
  };

  const handleBloomDayClick = () => {
    navigate("/news/bloom-day");
  };

  const handleJiuJitsuClick = () => {
    navigate("/news/jiu-jitsu");
  };

  return (
    <div style={{ background: "#fafafa", padding: "24px" }}>
      <Row gutter={[24, 24]} justify="center">
        {/* LEFT SIDE — Sidebar Cards */}
        <Col xs={24} md={8} lg={6}>
          {/* Header Card */}
          <Card
            style={{
              background: "#4b007d",
              color: "#fff",
              borderRadius: "10px",
              padding: "16px",
            }}
            bordered={false}
          >
            <Title level={4} style={{ color: "#fff", marginBottom: 4 }}>
              Yalla Nellab News
            </Title>
            <Text 
              style={{ color: "#d9d9d9", cursor: "pointer" }}
              onClick={handleViewAll}
            >
              View all
            </Text>
          </Card>

          {/* News Card 1 - Bloom Day */}
          <Card
            hoverable
            onClick={handleBloomDayClick}
            cover={
              <img
                alt="Bloom Day"
                src={card1}
                style={{ height: 140, objectFit: "cover" }}
              />
            }
            style={{ marginTop: 16, borderRadius: 10, cursor: "pointer" }}
          >
            <Title level={5} style={{ marginBottom: 8 }}>
              Bloom Day: Yalla Nellab Announces a New Initiative for Special
              Children
            </Title>
            <Text type="secondary" style={{ fontSize: 13 }}>
              Read More →
            </Text>
          </Card>

          {/* News Card 2 - Jiu-jitsu */}
          <Card
            hoverable
            onClick={handleJiuJitsuClick}
            cover={
              <img
                alt="Jiu-jitsu"
                src={card2}
                style={{ height: 140, objectFit: "cover" }}
              />
            }
            style={{ marginTop: 16, borderRadius: 10, cursor: "pointer" }}
          >
            <Title level={5} style={{ marginBottom: 8 }}>
              Jiu-jitsu is Rising in the UAE
            </Title>
            <Text type="secondary" style={{ fontSize: 13 }}>
              Read More →
            </Text>
          </Card>
        </Col>

        {/* RIGHT SIDE — Heroes Cup Article (Same layout as BloomNews) */}
        <Col xs={24} md={16} lg={18}>
          <div
            style={{
              borderRadius: 10,
              overflow: "hidden",
              position: "relative",
            }}
          >
            {/* Purple overlay background */}
            <div
              style={{
                background: "linear-gradient(to bottom, #4b007d 30%, transparent 70%)",
                borderRadius: 10,
                overflow: "hidden",
              }}
            >
              <img
                alt="Heroes Cup"
                src={mainImage}
                style={{
                  width: "100%",
                  height: "auto",
                  display: "block",
                  opacity: 0.95,
                }}
              />
            </div>

            {/* Article content */}
            <div
              style={{
                background: "#fff",
                borderTopLeftRadius: 20,
                borderTopRightRadius: 20,
                padding: "24px",
                marginTop: "8px",
              }}
            >
              <Title level={3}>
                Heroes Cup: Tournament dedicated to honoring laborers
              </Title>

              <Title level={5}>A Tribute to the Labor Community</Title>
              <Paragraph>
                The Heroes Cup is a special event by Yalla Nellab that
                celebrates the dedication and strength of the labor community.
                It provides workers with an opportunity to step away from their
                daily routines and take part in exciting sports activities that
                bring joy, pride and recognition.
              </Paragraph>

              <Title level={5}>Celebrating Teamwork and Passion</Title>
              <Paragraph>
                The tournament features games such as football and cricket,
                where participants compete with energy and determination. Every
                match is filled with teamwork, enthusiasm and the true spirit of
                sportsmanship. The event highlights that everyone deserves a
                chance to shine, no matter where they come from.
              </Paragraph>

              <Title level={5}>More Than Just a Tournament</Title>
              <Paragraph>
                The Heroes Cup goes beyond competition. It is a celebration of
                unity, respect and community. Yalla Nellab created this event to
                remind everyone that the real heroes are those who work hard
                every day and continue to inspire through their resilience and
                spirit.
              </Paragraph>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default HeroesNewsDetail;